module.exports = __webpack_public_path__ + "bcfa4e7e16939e70dc6faff489ce87ef.jpg";